import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { AssetsTotalCountResponse } from '@fleet-bffs/api-contract';

export const initialState: Fields = {
  isLoaded: false,
  isLoading: false,
};

export interface Fields {
  totalAssetsCount?: number;
  totalBatteriesCount?: number;
  totalSubcategoryBatteriesCount?: number;
  totalGatewaysCount?: number;
  totalMachinesCount?: number;
  totalRoboticMowersCount?: number;
  isLoading: boolean;
  isLoaded: boolean;
  assetCreatedDate?: Date;
  assetDeletedDate?: Date;
}

const reducer = createSlice({
  name: 'assets-counts',
  initialState,
  reducers: {
    setIsLoaded: (state, action: PayloadAction<boolean>) => {
      state.isLoaded = action.payload;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    importAssetsTotalCountResponse: (state, action: PayloadAction<AssetsTotalCountResponse>) => {
      state.totalAssetsCount = action.payload.typesCounts.totalAssetsCount;
      state.totalRoboticMowersCount = action.payload.typesCounts.totalRoboticMowersCount;
      state.totalMachinesCount = action.payload.typesCounts.totalMachinesCount;
      state.totalBatteriesCount = action.payload.typesCounts.totalBatteriesCount;
      state.totalGatewaysCount = action.payload.typesCounts.totalGatewaysCount;
      state.totalSubcategoryBatteriesCount = action.payload.subcategoriesCounts.totalBatteriesCount;
    },
    refreshAssetCreatedDate: (state) => {
      state.assetCreatedDate = new Date();
    },
    refreshAssetDeletedDate: (state) => {
      state.assetDeletedDate = new Date();
    },
  },
});

export const {
  setIsLoaded,
  setIsLoading,
  importAssetsTotalCountResponse,
  refreshAssetCreatedDate,
  refreshAssetDeletedDate,
} = reducer.actions;

export default reducer.reducer;
